import { useState } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
} from '@mui/material';
import {
  Assignment as AssignmentIcon,
  Compare as CompareIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import DiscDashboardIndividualTest from './DiscDashboardIndividualTest';
import DiscDashboardComparison from './DiscDashboardComparison';

function TabPanel({ children, value, index }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`disc-dashboard-tabpanel-${index}`}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const DiscDashboard = () => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(0);

  return (
    <Box sx={{ width: '100%', py: 3, px: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h5" gutterBottom>
            {t('disc.dashboardTitle')}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t('disc.dashboardSubTitle')}
          </Typography>
        </Box>
      </Box>

      {/* Tabs internos */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={tabValue} onChange={(e, newValue) => setTabValue(newValue)}>
          <Tab label={t('disc.individualTests')} id="disc-dashboard-tab-0" icon={<AssignmentIcon />} iconPosition="start" />
          <Tab label={t('disc.comparisons')} id="disc-dashboard-tab-1" icon={<CompareIcon />} iconPosition="start" />
        </Tabs>
      </Box>

      {/* Tab Panel 0: Tests Individuales */}
      <TabPanel value={tabValue} index={0}>
        <DiscDashboardIndividualTest />
      </TabPanel>

      {/* Tab Panel 1: Comparaciones */}
      <TabPanel value={tabValue} index={1}>
        <DiscDashboardComparison />
      </TabPanel>
    </Box>
  );
};

export default DiscDashboard;